// Copyright 2025 Sorama B.V.
import { autoinject } from "aurelia-dependency-injection";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import {
    IWorkflowModuleInstance,
    IWorkflowModuleModalInstance,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { CSVExportModalState } from "../CSVExport/CSVExportModal";
import { ImageExportState } from "../ImageExport/ImageExportModal";

export interface IExportModule {
    imageState: { state: ImageExportState; moduleInstance: IWorkflowModuleInstance };
    csvState?: { state: CSVExportModalState; moduleInstance: IWorkflowModuleInstance };
    csvExportCall?: () => void;
}

@autoinject
export class ExportModal implements IModal<ExportModalState<IExportModule>> {
    public belongsTo: IExportModule;

    public availableFormats: { name: string }[] = [
        { name: "Choose an option" },
        { name: "Data (CSV)" },
        { name: "Visual (Image, Video)" },
    ];
    public selectedFormat: string;

    activateModal(
        state: ExportModalState<IExportModule>,
        moduleInstance: IWorkflowModuleModalInstance<ExportModalState<IExportModule>>
    ): void {
        this.belongsTo = state.belongsTo;
    }
}

export class ExportModalState<TModule> {
    public belongsTo: TModule;
}
